module.exports = __webpack_public_path__ + "img/ea.ce841725.svg";